import { JAVA_SERVICE_ENDPOINTS, JavaAPI } from '@buildwise/libs/services';

class FilesAPI extends JavaAPI {
  public getFiles(companyId: string, level: 'company' | 'project', projectId?: string) {
    const params = new URLSearchParams({
      level,
      ...(projectId && { projectId }),
    });

    return this.get(
      `${JAVA_SERVICE_ENDPOINTS.COMPANY_FILES.replace(':companyId', companyId)}?${params.toString()}`,
    );
  }
}

export default new FilesAPI();
